"use strict";

export function initInScope ($scope) {
    console.log('debug info');
    let copyrightItem = $scope.find('.js-img-copyright');
    copyrightItem.on('click', function (evt) {
        evt.stopPropagation();
        $(this).toggleClass('active');
    })
}